import { GET_CAMPAIGN_RULES, GET_CAMPAIGN_RULES_SUCCESS, GET_CAMPAIGN_RULES_ERROR, GET_CAMPAIGN_RULES_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetCampaignRules = (state = initialState, action) => {
  switch (action.type) {
    case GET_CAMPAIGN_RULES:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_CAMPAIGN_RULES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_CAMPAIGN_RULES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_CAMPAIGN_RULES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetCampaignRules;
